import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const DisabledMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Disabled extends Clazz {
    @Input()
    protected _disabled: boolean = false;

    public get disabled(): boolean {
      return this._disabled;
    }

    public set disabled(value: boolean) {
      this._disabled = value;
    }

    @Output()
    public disabledChange = new EventEmitter<boolean>();

    setDisabledState?(isDisabled: boolean): void {
      this.disabled = isDisabled;
    }
  }

  return Disabled;
};

export const DisabledMixinInputs = ["disabled"];
